export const searchTranslation = {
  open_case: 7437,
  edit_case: 7485,
  assigned_to: 7438,
  search_title: 5537,
  filters_title: 7556,
  filters_included: 7643,
  filters_excluded: 7642,
  input_placeholder: 7475,
  search_no_hits: 7548,
  search_hits: 7474,
  loading: 7486,
  view_as: 7546,
  case_delete_title: 5790,
  case_delete_description: 7489,
  case_delete_continue: 5790,
  case_delete_cancel: 3273,
  case_duplicate_title: 7492,
  cases_results: 7499,
  case_report_title: 7500,
  sort_order_title: 7545,
  sort_order_button_add_sort_param: 7543,
  sort_order_button_done: 7338,
  sort_order_sort_by: 7534,
  sort_order_menu_option_remove: 5913,
  sort_order_menu_option_move_up: 7743,
  sort_order_menu_option_move_down: 7538,
  sort_order_asc: 7537,
  sort_order_desc: 7536,
  sort_order_select_text_select_from_list: 7535,
  sort_order_no_sort_options: 7552,
  create_report_title: 7775,
  update_report_title: 8322,
  show_details: 7640,
  hide_details: 7641,
  export_title: 7869,
  done: 7338,
  excel_edit_cases: 6798,
  excel_edit_cases_with_actions: 6806,
  excel_modal_title: 7955,
  excel_modal_description: 7954,
  excel_modal_ok_button: 7953,
  excel_modal_cancel_button: 7956,
  download_frequency_report_title: 7996,
  download_selection_report_title: 7997,
  download_report_wait: 8012,
  download_report_success: 7873,
  open_in_survey_manager: 7122,
  print_displayed: 8362,
  some_fields_are_filled_out_incorrectly: 7702
};

export const endpoint = {
  reportCategory: 'report/options',
  favouriteReportSortOptions: 'case/report/sortOptions',
  favouriteDefinition: 'favourite/definition/draft',
  searchFavouriteDefinition: 'favourite/definition/draft/template/search',
  connectedCasesFavouriteDefinition: 'favourite/definition/draft/template/connectedCases',
  duplicateRegistrationsFavouriteDefinition: 'favourite/definition/draft/template/connectedCases',
  specialReport: 'report/specialReport',
  downloadReportToExcel: 'statisticalReport/excel',
  getExternalUrl: (externalUrlId: number) => `externalUrl/${externalUrlId}`,
  loadUsersMetadata: 'favourite/definition/draft/options/users/metadata',
  specialReportFavouriteDefinition: 'favourite/definition/draft/template/specialReport'
};

export const debounceTime = 80;

export enum reportTypes {
  selectionReport = 6,
  frequencyReport = 10,
  mergedReport = 13,
  specialReport = 11,
  dashboard = 345,
  bowtieConnectedCasesInfo = 355
}

export enum openReportState {
  new = 'new',
  edit = 'edit'
}

export const searchInAllFieldsDomain = 3613;
